import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BaseComponent } from "@rubii/frontend-common";


@Component({
    selector: 'app-search-inline',
    templateUrl: './search-inline.component.html',
    styleUrls: ['./search-inline.component.scss'],
})
export class SearchInlineComponent extends BaseComponent implements OnInit {
    @Input() width: number = 285;
    @Input() placeholderStr: string = '';
    @Output() keywordChange: EventEmitter<string> = new EventEmitter();
 

    keyword = '';
    searchTime: any = null;

    searchUser() {
        if (this.searchTime !== null) {
            clearTimeout(this.searchTime);
        }
        let that = this;
        this.searchTime = setTimeout(function () {
            that.keywordChange.emit(that.keyword);
        }, 500);
    }
}